import { connect } from 'react-redux'

import {
  getTaskWithFilter,
  setTaskStatusList,
  projectInput,
  setSelectedTaskStatus,
} from 'reduxpath/ducks/TaskList/List'

import SearchBox from './units'

const mapStateToProps = state => ({
  taskStatusList: state.Reference.statusDefinition.task,
  searchProjectName: state.TaskList.searchProjectName,
  selectedTaskStatus: state.TaskList.selectedTaskStatus,
  param: {
    searchProjectName: state.TaskList.searchProjectName,
    taskStatus: state.TaskList.taskStatus,
  },
})

const mapDispatchToProps = dispatch => ({
  onInputChange(e) {
    e.preventDefault()
    dispatch(projectInput(e.target.value))
  },

  handleSelectedtaskStatus() {
    return (e) => {
      e.preventDefault()
      dispatch(setSelectedTaskStatus(e.target.value))
      dispatch(setTaskStatusList(e.target.value))
    }
  },

  submitFilters(param) {
    return (e) => {
      e.preventDefault()
      const {
        searchProjectName,
        taskStatus,
       } = param
      let qs = {}
      if (searchProjectName !== '') {
        qs = {
          sort: 'deadline ASC',
          skip: 0,
          limit: 10,
          where: {
            order: {},
          },
        }
      } else if (taskStatus !== '') {
        qs = {
          sort: 'deadline ASC',
          skip: 0,
          limit: 10,
          where: {},
        }
      } else {
        qs = {
          sort: 'deadline ASC',
          skip: 0,
          limit: 10,
        }
      }
      if (searchProjectName) {
        qs.where.orderName = {
          like: `%${searchProjectName}%`,
        }
      }

      if (taskStatus) {
        qs.where.status = taskStatus
      }
      dispatch(getTaskWithFilter(qs))
    }
  },

})

function mergeProps(stateProps, dispatchProps) {
  return {
    ...stateProps,
    ...dispatchProps,
    submitFilters: dispatchProps.submitFilters(stateProps.param),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SearchBox)
